var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 107,
    viewBox: "0 0 134 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.71 0.358887H0.339417V89.1057H115.71V0.358887ZM106.836 80.231H9.2141V9.23357H106.836V80.231Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.585 22.5457V97.9805H22.5262V106.855H133.46V22.5457H124.585Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0247 66.492C69.0349 66.492 77.9927 56.7473 77.9927 44.7696C77.9927 32.7918 69.0349 23.0471 58.0247 23.0471C47.0146 23.0471 38.0567 32.7915 38.0567 44.7696C38.0567 56.7476 47.0146 66.492 58.0247 66.492ZM58.0247 31.9218C64.1416 31.9218 69.1181 37.6854 69.1181 44.7696C69.1181 51.8538 64.1416 57.6173 58.0247 57.6173C51.9078 57.6173 46.9314 51.8538 46.9314 44.7696C46.9314 37.6854 51.9078 31.9218 58.0247 31.9218Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9635 20.3269H18.0888V69.1377H26.9635V20.3269Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9608 20.3269H89.0861V69.1377H97.9608V20.3269Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.cc41732634c4152e5d6143eb3ebbe5c6.svg";
export { ForwardRef as ReactComponent };